import AppletHeader from './applet-header.vue'

/**
 * UI components shared by all applets, keyed by tag name
 */
export const components = {
  'artup-applet-header': AppletHeader
}

/**
 * Installs UI components into the application
 * @param {Application} application Vue application instance
 * @param {Dictionary<String, Vue>} components Dictionary of components to install, where key is component tag
 */
export function useComponents (application, components = {}) {
  if (!application) throw new Error('Application is required')

  const plugin = {
    install (application) {
      for (const [tag, component] of Object.entries(components)) {
        application.component(tag, component)
      }
    }
  }

  application.use(plugin)
}
